import React from 'react';
import PolicyPage from './PolicyPage';

const sections = [
  {
    heading: 'Information We Collect',
    paragraphs: [
      'TUR DER HOFFNUNG may collect personal information such as your name, email address, phone number, billing details, and any information you submit through contact or payment forms.',
      'We may also collect basic technical information such as browser type, device data, and website usage details for security and service improvement.',
    ],
  },
  {
    heading: 'How We Use Information',
    paragraphs: [
      'We use collected information to respond to inquiries, process payments, provide customer support, maintain records, and comply with legal and regulatory obligations.',
      'Your information may also be used to detect fraud, improve website performance, and protect the security of our services.',
    ],
  },
  {
    heading: 'Data Sharing',
    paragraphs: [
      'We do not sell your personal information. We may share necessary data with payment processors, hosting providers, or professional service partners only when required to operate the website or comply with the law.',
      'All third-party access is limited to the extent necessary for service delivery, security, or legal compliance.',
    ],
  },
  {
    heading: 'Contact',
    paragraphs: [
      'For privacy-related questions, please contact TUR DER HOFFNUNG at 50 Rawdon Street, Freetown, Sierra Leone, or through https://turderhoffnung.com.',
    ],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <PolicyPage
      title="Privacy Policy"
      subtitle="Privacy Policy"
      sections={sections}
    />
  );
}
